/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $("#searchform").prependTo("body");

        $( "#showsearch" ).on( "click", function(e) {
            e.preventDefault();
            $("#searchform input.search-field").focus();
            $("html").toggleClass('showsearch');
        });
        $( "#searchclose" ).on( "click", function(e) {
            e.preventDefault();
            $("html").removeClass('showsearch');
        });

        $( ".nav-primary" ).clone().prependTo( "body" ).removeClass("nav-primary").addClass("nav-mobile");

        $( "header.banner" ).append( '<i id="navtoggle" class="ico ico-Icon_BurgerMenue" aria-hidden="true"></i> ');
        $( "#navtoggle" ).on( "click", function() {
            $("html").toggleClass('shownav');
        });
        $( ".shownav .doc" ).on( "click", function() {
            $("html").removeClass('shownav');
            alert("hidenav");
        });

        // // Supermenu Background
        // $( "header.banner" ).append( '<div id="fullwidthbg"></div>' );
        // $("#menu-mainnavigation .supermenu,#fullwidthbg").hover(
        //   function() {
        //     var menu_height = $(this).find(".sub-menu").innerHeight();
        //     $( "header.banner" ).addClass("supershow");
        //     $("#fullwidthbg").height(menu_height).show();
        //   }, function() {
        //     $( "header.banner" ).removeClass("supershow");
        //     $("#fullwidthbg").hide();
        //   }
        // );

        $('a#scrolltop').on('click', function(e){
          $('html, body').animate({
            scrollTop: 0
          },'slow');
          e.preventDefault();
        });

        // Isotope
        if ( $('.grid').length ) {

          // init Isotope
          var $grid = $('.grid').isotope({
            // options
            itemSelector: '.item',
            percentPosition: true,
            masonry: {
              columnWidth: '.grid-sizer',
              gutter: '.gutter-sizer'
            }
          });

          // layout Isotope after each image loads
          $grid.imagesLoaded().progress( function() {
            $grid.isotope('layout');
          });

        }

        // Isotope Posts
        if ( $('#posts').length && false ) {

          var $container = $('#posts').isotope({
            itemSelector : '.item',
            isFitWidth: true,
            gutter: 15
          });

          /* $container.isotope({ filter: '*' }); */

          $container.imagesLoaded().progress( function() {
            $container.isotope('layout');
          });


        	// Infinite Scroll
          /*
          $container.infinitescroll({
              navSelector  : '.nav-links',    // selector for the paged navigation
              nextSelector : '.nav-previous a',  // selector for the NEXT link (to page 2)
              itemSelector : '.item',     // selector for all items you'll retrieve
        	  loadingText  : "",
              loading: {
                  finishedMsg: '',
                  img: ''
                }
              },
              // trigger Masonry as a callback
              function( newElements ) {
                console.log(newElements);
                // hide new items while they are loading
                var $newElems = $( newElements ).css({ opacity: 0 });
                // ensure that images load before adding to masonry layout
                $newElems.imagesLoaded(function(){
                  // show elems now they're ready
                  $newElems.animate({ opacity: 1 });
                  $container.isotope( 'appended', $newElems, true );
                });
              }
            );
            */

          /*
            // filter items on button click
          $('#filters').on( 'click', 'button', function() {
            var filterValue = $(this).attr('data-filter');
            $container.isotope({ filter: filterValue });
          });
          */

        }

        if ($('.ws-advent').length) {
          if ($('.is-canvas').length) {
            $('.ws-advent__door').addClass('ws-advent__door--active');
          } else {
             $.urlParam = function(name){
                 var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                 if (results==null) {
                    return null;
                 }
                 return decodeURI(results[1]) || 0;
             }

             function WsAdvent($calendar) {
               var currentDate = new Date();
               console.log($.urlParam('dez'));
               if ($.urlParam('dez')) {
                var month = 12;
                var day = parseInt($.urlParam('dez'));
               } else {
                var day = currentDate.getDate();
                var month = currentDate.getMonth() + 1;
               }
               var doors = [];
               $calendar.find('.ws-advent__door').each(function(){
                 doors.push(new Door($(this)));
               });
               function Door($door) {
                 $door.on('click',open);
                 var theDay = parseInt($door.find('.ws-advent__day').text());
                 if (month == 12 && theDay && theDay <= day) $door.addClass('ws-advent__door--active');
                 var $content = $door.find('.ws-advent__content');
                 $content.html('<div class="ws-advent__content-fold">' + $content.html() + '</div>');
                 $content.addClass('ws-advent__content--frontend').appendTo('.doc');
                 var $close = $('<div class="ws-advent__close"></div').prependTo($content).on('click',close);
                 function open() {
                   $door.addClass('ws-advent__door--open');
                   $content.addClass('ws-advent__content--active');
                 }
                 function close() {
                   $door.removeClass('ws-advent__door--open');
                   $content.removeClass('ws-advent__content--active');
                 }
                 var offset;
                 var width;
                 var height;
                 function resized() {
                   offset = $door.offset();
                   width = $door.outerWidth();
                   height = $door.outerHeight();
                   scrolled();
                 }
                 function scrolled() {
                   $content.css('transform-origin', (offset.left + width / 2) + 'px ' + (offset.top + height / 2 - window.pageYOffset ) + 'px' );
                 }
                 resized();
                 $(window).on('resize',resized);
                 $(window).on('scroll',scrolled);
               }
             }
             $('.ws-advent').each(function(){
               var wsAdvent = new WsAdvent($(this));
             });
          }
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
    },
    'single_industries': {
      init: function() {

        // Example with multiple objects
        $('.open-modal').magnificPopup({
          type: 'inline',
            gallery: {
            // options for gallery
            enabled: false
          },
          midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        });

        size_li = $(".samples li").hide().size();

        x=15;
        $('.samples li:lt('+x+')').show();
        $('.samples li.loadmore').hide();
        if(size_li > x){
          $('.samples li.loadmore').show();
        }
        $('.samples li.loadmore a').click(function (e) {
            e.preventDefault();
            //x= (x+5 <= size_li) ? x+5 : size_li;
            $('.samples li').show();
            $(this).parent().hide();
        });

      }
    }
  };

  currentLang =  $( "#showsearch").parent().find("a.current-language-item").parent().detach();
  currentLang = currentLang.find("a").html();
  $( "#showsearch" ).next().find(".mlp_language_box ul").addClass("submenu").wrap('<ul><li><a id="showlangs" href="#"></a></li></ul>');
  //$( "#showlangs" ).prepend(currentLang).prepend('<i class="ico ico-Icon_Globe" aria-hidden="true"></i>');
  $( "#showlangs" ).prepend('<i class="ico ico-Icon_Globe" aria-hidden="true"></i> <i class="ico ico-Icon_Arrow" aria-hidden="true"></i>');

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // shortcode if_cookies
  function getCookieValue(a) {
      var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
      return b ? b.pop() : '';
  }
  if ($('.ws-if-cookies').length && getCookieValue('cookie_notice_accepted') === 'true') $($('.ws-if-cookies').contents()[0].data.trim()).insertAfter('.ws-if-cookies');


})(jQuery); // Fully reference jQuery after this point.